const FooterData =
    [
        {
            link: '/about_us',
            title: 'About Us'
        },
        {
            link: '/beneficiary-corner',
            title: 'Beneficiary Corner'
        },
        {
            link: '/publication',
            title: 'Publications'
        },
        {
            link: '/notifications',
            title: 'Notifications'
        },
        // {
        //     link: 'rti',
        //     title: 'RTI'
        // },
        {
            link: '/contact',
            title: 'Contact us'
        },

        // {
        //     link: 'contact',
        //     title: 'Contact us'
        // },
        // {    
        //     link: 'login',
        //     title: 'Login'
        // },
    ]

export default FooterData